
import { mapState } from "vuex";
import { campaignMixin } from "~/mixins";
import { getPrismicTime } from "~/utils/prismic-utils.js";

export default {
  mixins: [campaignMixin],

  props: {
    isBundleProduct: { type: Boolean, default: false },
    selectedVariant: { type: Object, default: () => {} },
    quickview: { type: Boolean, default: false },
  },

  data() {
    return {
      countdownInterval: null,
      countdownText: "",
    };
  },

  computed: {
    ...mapState("wishlist", ["modalTypes"]),
    ...mapState("pdp", ["isMembersInfoVisible"]),

    rrpText() {
      return this.showRRPText
        ? this.priorityCampaign.value?.rrpText ?? "RRP"
        : "";
    },
    compareAtPrice() {
      return this.selectedVariant?.compareAtPrice;
    },
    price() {
      return this.selectedVariant.price;
    },
    campaignLabel() {
      return this.priorityCampaign.value?.timerLabel || "";
    },
    isMemberCampaign() {
      return (
        this.campaignTitle === "member-campaign" ||
        this.campaignTitle === "velocity-campaign"
      );
    },
    campaignOfferModalProps() {
      return {
        isOpen: this.isMembersInfoVisible,
        termsAndConditions: this.priorityCampaign?.value?.termsAndConditions,
        bgColor: this.saleTagBgColor,
        modalTitle:
          this.campaignTitle === "member-campaign"
            ? "Snooze Members Offer"
            : "Velocity Members Offer",
        buttonLabel:
          this.campaignTitle === "member-campaign"
            ? "Become a Snooze Member for free"
            : "Learn More",
      };
    },
  },

  mounted() {
    const { showTimerLabel, endTime } = this.priorityCampaign.value || {};

    if (showTimerLabel && endTime && getPrismicTime(endTime) > Date.now()) {
      this.updateCountdown();
      this.countdownInterval = setInterval(this.updateCountdown, 1000);
    }
  },

  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    this.$store.dispatch("pdp/setMembersInfoVisibility", false);
  },

  methods: {
    formatAmount(amount) {
      return this.campaignTitle === "was-now"
        ? this.$options.filters.formatCurrency(amount, false, true, false)
        : this.$options.filters.formatCurrency(amount);
    },
    handleJoinMemberClick() {
      if (this.campaignTitle === "member-campaign") {
        this.$store.dispatch("wishlist/openModal", {
          type: this.modalTypes.MEMBERSHIP_MODAL,
        });

        return;
      }

      const documentLink = this.priorityCampaign.value?.documentLink;

      if (!documentLink) {
        return;
      }

      const url = this.$prismic.asLink(documentLink);
      const { href } = this.$router.resolve(url);

      window.open(href, "_blank", "noopener,noreferrer");
    },
    handleClick() {
      this.$store.dispatch("pdp/setMembersInfoVisibility", true);
    },
    handleClose() {
      this.$store.dispatch("pdp/setMembersInfoVisibility", false);
    },
    updateCountdown() {
      const endTime = this.priorityCampaign.value?.endTime;

      if (!endTime) {
        this.countdownText = "";
        return;
      }

      const diff = getPrismicTime(endTime) - Date.now();

      if (diff <= 0) {
        this.countdownText = "";

        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }

        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.countdownText = [
        days > 0 ? `${days}d` : null,
        `${String(hours).padStart(2, "0")}h`,
        `${String(minutes).padStart(2, "0")}m`,
        `${String(seconds).padStart(2, "0")}s`,
      ]
        .filter(Boolean)
        .join(" ");
    },
  },
};
